const filterItems = document.querySelectorAll('[js-sc-filter-item]');
const domains = document.querySelectorAll('[js-sc-domain]');
const filterContainer = document.querySelector('[js-filter-container]');
const activeClass = 'is-active';


if (window.innerWidth > 960) {
    document.addEventListener('scroll', ()=> {
        let filterOffsetTop = filterContainer.getBoundingClientRect().top + window.pageYOffset;

        // console.log(filterOffsetTop)

        domains.forEach((domain, i) => {
            let domainOffsetTop = domain.getBoundingClientRect().top + window.pageYOffset;
            let domainHeight = domain.getBoundingClientRect().height;

            if (filterOffsetTop > domainOffsetTop && filterOffsetTop < domainOffsetTop + domainHeight) {
                let activeFilter = document.querySelector('[js-sc-filter-item].is-active');
                if (activeFilter) {
                    activeFilter.classList.remove(activeClass)
                }
                if (!filterItems[i].classList.contains(activeClass)) {
                    filterItems[i].classList.add(activeClass)
                }
            }
        })
    })
}


